import { Box } from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface InfoProps {
  id: string;
  updatedAt: string;
  createdAt: string;
  authorName: string;
  status: string;
  title: string;
}

export const SIGNATURE_ENVELOPE_STATUS_KEYS = {
  PENDING: "sign.info.statusPending",
  SIGNED: "sign.info.statusSigned",
  SIGNATURE_STARTED: "sign.info.statusInProgress",
  COMPLETED: "sign.info.statusCompleted",
  CANCELLED: "sign.info.statusCancelled",
};

function Info({
  id,
  updatedAt,
  createdAt,
  authorName,
  status,
  title,
}: InfoProps): React.JSX.Element {
  const { t } = useTranslation();
  const statusKey = SIGNATURE_ENVELOPE_STATUS_KEYS[status as keyof typeof SIGNATURE_ENVELOPE_STATUS_KEYS];
  const statusFormatted = statusKey ? t(statusKey) : status;
  return (
    <>
      <Stack direction="row">
        <Typography
          sx={{
            fontWeight: "400",
            fontSize: 16,
            mr: 2,
          }}
          variant="body1"
        >
          {t("sign.info.envelope")}{" "}
        </Typography>
        <Typography
          sx={{
            fontWeight: "400",
            fontSize: 16,
            color: "action.active",
          }}
          variant="body1"
        >
          {id}
        </Typography>
      </Stack>
      <Box>
        <Typography sx={{ fontWeight: "500", fontSize: 20 }} variant="h6">
          {title}
        </Typography>
      </Box>
      <Stack direction="row" sx={{ mt: 2 }}>
        {statusFormatted ? (
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: 16,
              mr: 2,
            }}
            variant="body1"
          >
            {statusFormatted}
          </Typography>
        ) : null}
        <Typography
          sx={{
            fontWeight: "400",
            fontSize: 16,
            color: "action.active",
            mr: 1,
          }}
          variant="body1"
        >
          {t("sign.info.lastUpdate")}
        </Typography>
        <Typography
          sx={{
            fontWeight: "400",
            fontSize: 16,
          }}
          variant="body1"
        >
          {format(new Date(updatedAt), `dd/MM/yyyy '${t("sign.info.at")}' HH:mm:ss`)}
        </Typography>
      </Stack>
      <Stack alignContent="center" direction="row">
        <Typography
          sx={{
            fontWeight: "400",
            fontSize: 14,
            mr: 1,
            lineHeight: "28px",
          }}
          variant="body2"
        >
          {t("sign.info.sentOn", { date: format(new Date(createdAt), "dd/MM/yyyy") })}
        </Typography>
        <Typography
          sx={{
            fontWeight: "400",
            fontSize: 14,
            color: "action.active",
          }}
          variant="body1"
        >
          {authorName}
        </Typography>
      </Stack>
    </>
  );
}

export default Info;
